import { InAppMessageSchedule } from "./InAppMessageSchedule"
import { InAppMessageScheduleType } from "./InAppMessageScheduleType"

export class InAppMessageScheduleRequest {
  constructor(
    public readonly schedule: InAppMessageSchedule,
    public readonly scheduleType: InAppMessageScheduleType,
    public readonly requestedAt: number
  ) {}

  get delayMillis(): number {
    return this.schedule.time.deliverAt - this.requestedAt
  }

  toString(): string {
    return `InAppMessageScheduleRequest(scheduleType=${this.scheduleType}, requestedAt=${this.requestedAt})`
  }
}
